export default {
  '/pay': {
    name: 'pay_home',
    meta: {
      'zh-CN': {
        title: '无为-支付状态'
      }
    },
    component: () => import(/* webpackChunkName: "editor" */ '../../views/pay/home/index.vue')
  },
  '/pay/process': {
    name: 'pay_process',
    meta: {
      'zh-CN': {
        title: '无为-支付流程'
      }
    },
    component: () => import(/* webpackChunkName: "editor_app" */ '../../views/pay/process/index.vue'),
    children: [
      {
        name: 'paying',
        path: '/pay/process/paying',
        meta: {
          'zh-CN': {
            title: '无为-订单支付中'
          }
        },
        component: () => import(/* webpackChunkName: "editor_app" */ '../../views/pay/process/paying/index.vue')
      },
      {
        name: 'done',
        path: '/pay/process/done',
        meta: {
          'zh-CN': {
            title: '无为-订单已完成'
          }
        },
        component: () => import(/* webpackChunkName: "editor_app" */ '../../views/pay/process/done/index.vue')
      },
      {
        name: 'finish',
        path: '/pay/process/finish',
        meta: {
          'zh-CN': {
            title: '无为-查看订单已支付'
          }
        },
        component: () => import(/* webpackChunkName: "editor_app" */ '../../views/pay/process/finish/index.vue')
      }]
  },
  '/version': {
    name: 'version',
    meta: {
      'zh-CN': {
        title: '版本管理'
      }
    },
    component: () => import(/* webpackChunkName: "version" */ '../../views/editor/projectVersion/index.vue')
  }
}
